import React, { useEffect } from "react";
import { useState } from "react";
import {
  Autocomplete,
  Button,
  Card,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  getPurchaseOrderById,
  postPurchaseOrder,
  purchaseOrderActions,
} from "../../../redux/reducer/purchaseOrder/purchaseOrderReducer";
import { getVegetablePrice } from "../../../redux/reducer/vegetablePrice/vegetablePriceReducer";
import { getData, postDataWithParams } from "../../../service/Service";
import { Settings } from "@mui/icons-material";
import NumberFormatting from "../../helper/NumberFormatting";
import moment from "moment";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminPurchaseOrderTambah() {
  // Navigate
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.dataToken);
  const farmer = useSelector((state) => state.farmer.data);

  // Local State
  const [formData, setFormData] = useState({
    source: 1,
    purchaseOrderCode: "",
    farmerId: "",
    totalPrices: "",
    status: "",
    createdAt: "",
  });
  const [vegetablePrice, setVegetablePrice] = useState([]);
  const [stockVegetables, setStockVegetables] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [fetch, setFetch] = useState(false);
  const [validateFarmer, setValidateFarmer] = useState(true);

  useEffect(() => {
    handleAddOrderDetails();
  }, []);

  const getDataVegetablePrice = () => {
    let body = {};
    let params = {
      paginate: false,
    };
    postDataWithParams("/master/vegetable-price/search", token, body, params)
      .then((res) => {
        if (res.data.status === 200) {
          let farmerType = res.data.data.docs.filter(
            (item) => item.priceTypeId?.typeName === "farmers"
          );
          setVegetablePrice([...farmerType]);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err.response.message);
      });
  };

  const getDataVegetableStock = () => {
    let stockBody = {
      farmerId: formData.farmerId,
    };
    postDataWithParams(
      "/farmer/purchase-order/search/vegetables-stock",
      token,
      stockBody,
      {}
    )
      .then((res) => {
        if (res.data.status === 200) {
          setStockVegetables([...res.data.data]);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err.response.message);
      });
  };

  useEffect(() => {
    if (fetch) {
      getDataVegetablePrice();
      getDataVegetableStock();
      setFetch(false);
    }
  }, [fetch]);

  useEffect(() => {
    if (formData.farmerId.length > 0) {
      setFetch(true);
      setValidateFarmer(false);
    }
  }, [formData.farmerId]);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === "stockVegetables") {
      setFormData({
        ...formData,
        farmerId: e.target.farmerId._id,
      });
      let newOrderDetails = [
        {
          vegetablePriceId: e.target.value.vegetablePriceId._id,
          order: "",
          accept: 0,
          reject: 0,
          return: 0,
          deviation: 0,
          totalOrder: "",
          price: "",
        },
      ];
      setOrderDetails(newOrderDetails);
    }
  };

  // Handling Order Details
  const handleOrderDetails = (index) => (e) => {
    const newItems = [...orderDetails];
    newItems[index][e.target.name] = e.target.value;
    newItems[index]["totalOrder"] = parseInt(newItems[index]["order"]);
    if (formData.source === "2") {
      newItems[index]["vegetablePriceId"] =
        autoCompleteValue[index]?.vegetablePriceId?._id;
      newItems[index]["stock"] = parseInt(newItems[index]["order"]);
      newItems[index]["accept"] = parseInt(newItems[index]["order"]);
      newItems[index]["price"] =
        newItems[index]["totalOrder"] *
        autoCompleteValue[index]?.vegetablePriceId?.price;
    } else {
      newItems[index]["vegetablePriceId"] = autoCompleteValue[index]?._id;
      newItems[index]["price"] =
        newItems[index]["totalOrder"] * autoCompleteValue[index]?.price;
    }

    setFormData({
      ...formData,
      totalPrices: newItems.reduce(
        (acc, cur) => parseInt(acc) + parseInt(cur.price),
        0
      ),
    });
    setOrderDetails(newItems);
  };

  const handleAddOrderDetails = () => {
    setOrderDetails((prevItems) => [
      ...prevItems,
      {
        vegetablePriceId: "",
        order: "",
        accept: 0,
        reject: 0,
        return: 0,
        deviation: 0,
        totalOrder: "",
        price: "",
      },
    ]);
  };

  const handleDeleteOrderDetails = (value) => {
    let deletedData = [];
    for (let i = 0; i < orderDetails.length; i++) {
      if (i !== value) {
        deletedData.push(orderDetails[i]);
      }
    }
    setOrderDetails(deletedData);
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          data: {
            purchaseOrderCode: formData.purchaseOrderCode,
            farmerId: formData.farmerId,
            source: parseInt(formData.source),
            orderDetails: orderDetails,
            totalPrices: formData.totalPrices,
            status: formData.source === "2" ? 2 : 1,
            createdAt: moment(formData.createdAt).format(),
            createdBy: user.username,
            updatedBy: user.username,
          },
          token: token,
        };
        dispatch(postPurchaseOrder(data)).then((res) => {
          if (res.payload.status === 201) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getPurchaseOrderById(dataGetById)).then((result) => {
              dispatch(
                purchaseOrderActions.addPurchaseOrder(result.payload.data)
              );
              toast.success(res.payload.message);
              navigate("/petani/nota-petani");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      } else if (
        vegetablePrice.totalDocs !== vegetablePrice.docs.length &&
        value === 2
      ) {
        const getData = {
          params: {
            limit: vegetablePrice.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getVegetablePrice(getData));
      }
    }
  };

  const orderDetailsColumn = ["SAYURAN", "ORDER", "HARGA", "AKSI"];

  const handleGenerateCode = () => {
    getData("/farmer/purchase-order/generate-code", token, null)
      .then((res) => {
        setFormData({
          ...formData,
          purchaseOrderCode: res.data.data,
        });
        toast.success(res.data.message);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  const [autoCompleteValue, setAutoCompleteValue] = useState([]);

  const handleVegetablePrice = (e, index) => {
    let tempVegetablePrice = [...autoCompleteValue];
    tempVegetablePrice[index] = e;
    setAutoCompleteValue(tempVegetablePrice);
  };

  useEffect(() => {
    setOrderDetails([]);
    setAutoCompleteValue([]);
    handleAddOrderDetails();
  }, [formData.source]);

  console.log(vegetablePrice, "vegetablePrice");
  console.log(stockVegetables, "stockVegetables");

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          BUAT NOTA PETANI
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE NOTA PETANI
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 20, style: { background: "white" } }}
              required
              helperText={
                formData.purchaseOrderCode.length > 0
                  ? /^[A-Za-z]{2}-\d{5}/.test(formData.purchaseOrderCode)
                    ? ""
                    : "*Format Kode Petani salah"
                  : ""
              }
              size="small"
              error={
                formData.purchaseOrderCode.length > 0
                  ? /^[A-Za-z]{2}-\d{5}/.test(formData.purchaseOrderCode)
                    ? false
                    : true
                  : false
              }
              name="purchaseOrderCode"
              onChange={handleChange}
              value={formData.purchaseOrderCode}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
            <Button
              size="small"
              variant="contained"
              onClick={() => handleGenerateCode()}
            >
              <Settings />
            </Button>
          </FormControl>
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              SUMBER
            </Typography>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={formData.source}
              name="source"
              onChange={handleChange}
              style={{ display: "flex", flexDirection: "row" }}
            >
              <FormControlLabel value="1" control={<Radio />} label="Petani" />
              <FormControlLabel value="2" control={<Radio />} label="Stock" />
            </RadioGroup>
          </FormControl>
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              onChange={handleChange}
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {farmer.docs.length > 0 ? (
                farmer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>
          <Divider />
          <Typography
            marginTop={1}
            marginBottom={1}
            fontSize={14}
            color={"#2e473f"}
            variant="h6"
          >
            ORDER DETAIL
          </Typography>
          <table
            style={{
              width: "100%",
              marginBottom: "10px",
              borderCollapse: "collapse",
              borderRadius: "1em",
              overflow: "hidden",
            }}
          >
            <thead>
              {orderDetailsColumn.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {orderDetails.length > 0 &&
                orderDetails.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className={styles.tableCell}
                        style={{ width: "400px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          {formData.source === "2" ? (
                            <Autocomplete
                              id="auto-complete"
                              autoComplete
                              fullWidth
                              inputValue={autoCompleteValue[index]}
                              // value={autoCompleteValue[index]}
                              onChange={(event, newValue) => {
                                handleVegetablePrice(newValue, index);
                              }}
                              options={stockVegetables}
                              getOptionLabel={(option) =>
                                option.stockTotal !== undefined
                                  ? `(STOCK = ${option.stockTotal}) - ${option.vegetablePriceId?.vegetableName}`
                                  : ""
                              }
                              includeInputInList
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  InputLabelProps={{ shrink: true }}
                                  size="small"
                                  name="vegetablePriceId"
                                  style={{
                                    maxWidth: "400px",
                                    background: "white",
                                    marginRight: "10px",
                                  }}
                                  disabled={validateFarmer}
                                />
                              )}
                            />
                          ) : (
                            <Autocomplete
                              id="auto-complete"
                              autoComplete
                              fullWidth
                              inputValue={autoCompleteValue[index]}
                              onChange={(event, newValue) => {
                                handleVegetablePrice(newValue, index);
                              }}
                              options={vegetablePrice}
                              getOptionLabel={(option) =>
                                option.vegetableName !== undefined
                                  ? `${option.vegetableName} - ${option.unitWeight?.unitWeightId?.unitName}`
                                  : ""
                              }
                              includeInputInList
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  InputLabelProps={{ shrink: true }}
                                  size="small"
                                  name="vegetablePriceId"
                                  style={{
                                    maxWidth: "400px",
                                    background: "white",
                                    marginRight: "10px",
                                  }}
                                  disabled={validateFarmer}
                                />
                              )}
                            />
                          )}
                        </FormControl>
                      </td>

                      <td
                        className={styles.tableCell}
                        style={{ width: "350px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            disabled={validateFarmer}
                            error={false}
                            name="order"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.order}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                          {formData.source === "2" &&
                            item.order >
                              autoCompleteValue[index]?.stockTotal && (
                              <span style={{ fontSize: "10px", color: "red" }}>
                                Stock tidak cukup
                              </span>
                            )}
                        </FormControl>
                      </td>

                      <td
                        className={styles.tableCell}
                        style={{ width: "200px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                            required
                            disabled={validateFarmer}
                            size="small"
                            error={false}
                            name="price"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.price.toLocaleString("id", {
                              style: "currency",
                              currency: "IDR",
                            })}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            width: "100px",
                          }}
                        >
                          <AddIcon
                            className={styles.actionButtonEdit}
                            onClick={() => handleAddOrderDetails()}
                          />
                          {orderDetails.length > 1 && index !== 0 ? (
                            <RemoveIcon
                              className={styles.actionButtonEdit}
                              onClick={() => handleDeleteOrderDetails(index)}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <Divider />

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TOTAL HARGA
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true, style: { background: "white" } }}
              required
              size="small"
              error={false}
              name="totalPrices"
              onChange={handleChange}
              value={formData.totalPrices.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TANGGAL BUAT NOTA
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" } }}
              required
              type="datetime-local"
              size="small"
              error={false}
              name="createdAt"
              onChange={handleChange}
              value={formData.createdAt}
              // value={formData.totalPrices.toLocaleString("id", {
              //   style: "currency",
              //   currency: "IDR",
              // })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/petani/nota-petani")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
